"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
export default function BeautifulImageCarousel() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const images = [{
    id: 1,
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/03/Screenshot_20260225-120109_Facebook.webp?v=ml2xxdgxys",
    alt: "Вкусно ежедневно хранене"
  }, {
    id: 2,
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/03/Screenshot_20260225-120128_Facebook1.webp?v=65297kcvakl",
    alt: "Ястие със свежи съставки"
  }, {
    id: 3,
    src: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-3e5706a74f51e3cf966459603949ce72-V.webp?v=4z836rn88ts",
    alt: "Цветна презентация на чиния"
  }, {
    id: 4,
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/03/Screenshot_20260225-120355_Viber.webp?v=uri4rkdy0t",
    alt: "Апетитна ресторантска храна"
  }, {
    id: 5,
    src: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/rsz_1screenshot_20260214-133142_facebook-1-2.webp?v=zyj8fiulkg",
    alt: "Модерна атмосфера за хранене"
  }, {
    id: 6,
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/02/rsz_1img-3b727e97a5696010f28897a83f080d37-v.webp?v=xq3ysrhttj",
    alt: "Традиционен български специалитет"
  }, {
    id: 7,
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/02/rsz_screenshot_20260214-133236_facebook-1.webp?v=sv1q6eoecel",
    alt: "Селекция от здравословни салати"
  }, {
    id: 8,
    src: "https://mishmashinterpred.com/wp-content/uploads/2026/03/Screenshot_20260225-120155_Facebook1.webp?v=qc3weay00u",
    alt: "Домашни десерти"
  }, {
    id: 9,
    src: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-6ce3c7fc10e2caa4da36f325072c2724-V.webp?v=2duf2cojqtr",
    alt: "Готвач подготвящ храна"
  }, {
    id: 10,
    src: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-0147514a8efc2fafe02a54fdd04df7d4-V.webp?v=mtqqgpwnvy",
    alt: "Уютен интериор и места за сядане"
  }];
  return <section id="красив-снимков-карусел" ref={ref} className="py-16 md:py-24 bg-linear-to-br from-dark-background via-[#2A2F36] to-dark-background/90">
      <div className="container">
        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          <div className="text-center mb-12">
            <h2 className="mb-4 !text-[hsl(21,90%,48%)]">Като у дома... но по-вкусно!</h2>
            <p className="max-w-2xl mx-auto !text-[hsl(0,0%,100%)]">Погледни, опитай, влюби се. Разгледайте някои от нашите вкусни ястия и модерната атмосфера на заведението.</p>
          </div>

          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full max-w-6xl mx-auto">
            <CarouselContent className="-ml-4">
              {images.map((image, i) => <CarouselItem key={image.id} data-index={i} className="pl-4 mb-0 pb-0 md:basis-1/2 lg:basis-1/3">
                  <div className="overflow-hidden h-full p-0 mb-0 border-none bg-transparent shadow-none hover:shadow-none hover:translate-y-0">
                    <div className="aspect-[4/3] relative mb-0 pb-0">
                      <img src={image.src} alt={image.alt} className="w-full object-cover !h-[271.986px] mb-0 block border-none outline-none bg-transparent" />
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="flex -left-4 lg:-left-12" />
            <CarouselNext className="flex -right-4 lg:-right-12" />
          </Carousel>
        </div>
      </div>
    </section>;
}